import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class RestaurantRepository extends BaseRepository {
    private readonly staffPath;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/restaurants';
        this.staffPath = 'dashboard/staff/restaurants';
    }

    // public getAllRestaurantForStaff(date: string) {
    //     const path = this.staffPath + '/daily-order';
    //     const options = {params: new HttpParams().append('orderDate', date)};
    //     return super.get(path, options);
    // }

    public getOpenedRestaurants() {
        const path = this.path + '/opened';
        return super.get(path);
    }

    getAllForUser() {
        const path = this.staffPath + '/for-user/?dtoClass=FuckingSlimRestaurantDTO';
        return super.get(path);
    }
}
